import { Injectable } from '@angular/core';
import { AbstractControl, FormGroup, FormArray, ValidationErrors, ValidatorFn, FormControl } from '@angular/forms';

@Injectable({
    providedIn: 'root',
})
export class CustomValidatorService {
    constructor() {}

    private getValidatorErrorMessage(key: string, value?: any): string {
        const errors: any = {
            dateRequired: $localize`A valid date is required!`,
            validDateRangeRequired: $localize`A start date should be before end`,
        };

        return errors[key];
    }

    public getErrorMessage(control: AbstractControl): string {
        if (!control || !control.errors) {
            return '';
        }
        const firstError = Object.getOwnPropertyNames(control.errors)[0];
        return this.getValidatorErrorMessage(firstError, control.getError(firstError));
    }
    public occasionDatesValidator: ValidatorFn = (metadataFormGroup: AbstractControl): ValidationErrors | null => {
        if (!(metadataFormGroup instanceof FormGroup)) return null;

        const errors: { [key: number]: string[] } = {};

        const formArray = metadataFormGroup.get('occasion_dates') as FormArray;
        const alwaysOpen = metadataFormGroup.get('occasion_always_open') as FormControl;

        formArray.controls.forEach((group: AbstractControl, index: number) => {
            if (!(group instanceof FormGroup)) return;

            const { start_date, end_date, application_start_date, application_end_date } = group.value;

            const groupErrors: string[] = [];

            // 1. If start_date exists, end_date can be unset or set (no error)
            // 2. If end_date is set, start_date can't be unset
            if (end_date && !start_date) {
                groupErrors.push('Please select a start date when an end date is provided.');
            }

            // 3. If application_start_date exists, application_end_date can be unset or set (no error)
            // 4. If application_end_date is set, application_start_date can't be unset
            if (application_end_date && !application_start_date) {
                groupErrors.push('Please select an enrollment start date when an enrollment end date is provided.');
            }

            // 5. If application_start_date is set, at least the start_date should exist
            if ((application_start_date || application_end_date) && !start_date && !alwaysOpen.value) {
                groupErrors.push(
                    'Please select a start date when an enrollment date is provided and occasions is not always open.'
                );
            }

            if (groupErrors.length) {
                errors[index] = groupErrors;
                group.setErrors({ occasionDate: groupErrors });
            } else {
                group.setErrors(null);
            }
        });

        return Object.keys(errors).length ? { occasionDates: errors } : null;
    };
}
